import type { CodeSystem, ConceptMap, ValueSet } from '@medplum/fhirtypes'
import { SEEN_HEALTH_SYSTEM } from '#src/codeSystems.ts'

export const ASSESSMENT_QUESTIONS_SYSTEM = `${SEEN_HEALTH_SYSTEM}/CodeSystem/assessment-questions`
export const ASSESSMENT_ANSWERS_SYSTEM = `${SEEN_HEALTH_SYSTEM}/CodeSystem/assessment-answers`

// Our own clinical terminology, held as FHIR resources: the codes we record
// observations under, the codes of their answers, the reusable answer sets
// over those, and the links to standard codes such as LOINC.
export interface TerminologyLibrary {
  questionCodes: CodeSystem
  answerCodes: CodeSystem
  answerSets: ValueSet[]
  conceptMap: ConceptMap
}
